<template>
  <CustomUpdateDialog
    :dialogTitle="`افزودن فایل به ${resourceDetailTitle}`"
    dialogId="add-attachment-to-resource-file-section"
    okTitle="افزودن فایل"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendAddAttachmentRequest"
  >
    <BCol cols="12">
      <ResourceAttachmentTypePicker
        :defaultSelectedType="addAttachmentPayload.type"
        v-model="addAttachmentPayload.type"
      ></ResourceAttachmentTypePicker>
    </BCol>
    <BCol cols="12">
      <BFormGroup label="فایل" label-for="imageFile">
        <BFormFile
          v-model="addAttachmentPayload.file"
          ref="imageFile"
          id="imageFile"
          :accept="attachmentTypeMimeTypes[addAttachmentPayload.type]"
        ></BFormFile>
      </BFormGroup>
    </BCol>
    <BCol cols="12" v-if="uploaded">
      <p class="mb-0">در حال آپلود {{ uploaded + "%" }}</p>
      <b-progress animated v-model="uploaded" max="100" />
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedResourceDetailContent: {
      type: Object,
    },
  },
  data() {
    return {
      uploaded: null, // Webservice fill this value with upload percentage automatically
      isOkButtonDisabled: false,
      addAttachmentPayload: {
        resourceDetailContentSectionId: null,
        file: null,
        type: 1,
      },
      attachmentTypeMimeTypes: {
        1: ".jpg,.jpeg,.png",
        2: ".mp3,.wav",
        3: ".mp4,.mov",
        4: ".pdf",
        5: ".zip,.rar",
      },
    };
  },
  methods: {
    async sendAddAttachmentRequest() {
      try {
        this.addAttachmentPayload.resourceDetailContentSectionId =
          this.selectedResourceDetailContent.id;
        this.isOkButtonDisabled = true;
        let _this = this;
        let uploadAttachmentToResourceDetailSection =
          new UploadAttachmentToResourceDetailSection(_this);
        uploadAttachmentToResourceDetailSection.setFormData(
          helper.generateFormData(_this.addAttachmentPayload)
        );
        await uploadAttachmentToResourceDetailSection.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.uploaded = null;
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "فایل جدید با موفقیت به بخش اضافه شد.",
              },
            });
            _this.addAttachmentPayload = {
              resourceDetailContentSectionId: null,
              file: null,
              type: 1,
            };
            _this.$bvModal.hide("add-attachment-to-resource-file-section");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    resourceDetailTitle() {
      if (
        this.selectedResourceDetailContent &&
        this.selectedResourceDetailContent.title
      ) {
        return this.selectedResourceDetailContent.title;
      }
      return "";
    },
  },
  components: {
    ResourceAttachmentTypePicker,
    CustomUpdateDialog,
    BCol,
    BFormGroup,
    BFormFile,
    BProgress,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import ResourceAttachmentTypePicker from "@/views/components/Resources/ResourceAttachmentTypePicker.vue";
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import helper from "@/libs/Helper";
import { UploadAttachmentToResourceDetailSection } from "@/libs/Api/Resources";
import { BCol, BFormGroup, BFormFile, BProgress } from "bootstrap-vue";
</script>
